import { Route } from "@angular/router";
import { DashboardComponent } from "./pages/dashboard/dashboard.component";
import { MembersComponent } from "./pages/student/student-list/members-list.component";
import { AddStudentComponent } from "./pages/student/add-student/add-student.component";
import { CreateCenterComponent } from "./pages/center/create-center/create-center.component";
import { LogInComponent } from "./start-up/log-in/log-in.component";
import { AddClassComponent } from "./pages/class/add-class/add-class.component";
import { SettingsComponent } from "./pages/settings/settings.component";
import { FinanceComponent } from "./pages/finance/finance.component";
import { ProfileDetailsComponent } from "./start-up/profile-details/profile-details.component";
import { MemberEnrolledPageComponent } from "./pages/member/member-enrolled-page/member-enrolled-page.component";
import { CenterSelectPageComponent } from "./pages/center/center-select-page/center-select-page.component";
import { AuthGuard } from "./guards/auth.guard";
import { NoAuthGuard } from "./guards/no-auth.guard";
import { AttendanceComponent } from "./pages/attendance/attendance.component";
import { PlanDetailsComponent } from "./pages/plan-membership/plan/plan-details/plan-details.component";
import { AddPlanComponent } from "./pages/plan-membership/plan/add-plan/add-plan.component";
import { NavigationMasterComponent } from "./pages/user-access/usertype-master/usertype-master.component";
import { UsertypeMasterEntryComponent } from "./pages/user-access/usertype-master-entry/usertype-master-entry.component";
import { ClassListComponent } from "./pages/class/class-list/class-list.component";
import { ClassDetailsComponent } from "./pages/class/class-detail/class-details.component";
import { SystemSetupComponent } from "./pages/system-setup/system-setup.component";
import { PageNotFoundComponent } from "./pages/page-not-found/page-not-found.component";

import { NavigationComponent } from "./pages/navigation/navigation.component";
import { StatsReportsComponent } from "./pages/stats-reports/stats-reports.component";
import { AddCompanyComponent } from "./pages/masters/add-company/add-company.component";
import { AddRegionComponent } from "./pages/masters/add-region/add-region.component";
import { AddCityComponent } from "./pages/masters/add-city/add-city.component";
import { AddAreaComponent } from "./pages/masters/add-area/add-area.component";
import { FinanceDetailsComponent } from "./pages/finance/finance-details/finance-details.component";
import { AddPaymentComponent } from "./pages/finance/add-payment/add-payment.component";
import { ManualAttendanceComponent } from "./pages/attendance/manual-attendance/manual-attendance.component";
import { TrainerContractComponent } from "./pages/trainer-contract/trainer-contract.component";
import { InquiryFormComponent } from "./pages/student/inquiry-from/inquiry-form.component";
import { InquiryDataComponent } from "./pages/student/inquiry-data/inquiry-data.component";
import { AddEventComponent } from "./pages/Events/add-event/add-event.component";
import { EventListComponent } from "./pages/Events/event-list/event-list.component";
import { EventRegComponent } from "./pages/Events/event-reg/event-reg.component";
import { OrdersListComponent } from "./pages/Orders/orders-list/orders-list.component";
import { AddOrderComponent } from "./pages/Orders/add-order/add-order.component";
import { OrderStatusComponent } from "./pages/Orders/order-status/order-status.component";
import { ProductListComponent } from "./pages/product/product-list/product-list.component";

export const appRoutes: Route[] = [
  { path: "", redirectTo: "dashboard", pathMatch: "full" },
  {
    path: "login",
    component: LogInComponent,
  },
  {
    path: "dashboard",
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "members",
    component: MembersComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "create-center",
    component: CreateCenterComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "center-select-page",
    component: CenterSelectPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "settings",
    component: SettingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "finance",
    component: FinanceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "finance-details",
    component: FinanceDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "add-payment",
    component: AddPaymentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "profile-details",
    component: ProfileDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "member-enrolled-page",
    component: MemberEnrolledPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "attendance",
    component: AttendanceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "manual-attendance",
    component: ManualAttendanceComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "add-plan",
    component: AddPlanComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "plan-details",
    component: PlanDetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "user-master",
    component: NavigationMasterComponent,
    canMatch: [AuthGuard],
    data: { module: "user-master" },
  },
  {
    path: "user-type-master",
    component: UsertypeMasterEntryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "system-setup",
    component: SystemSetupComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "page-not-found",
    component: PageNotFoundComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "navigation",
    component: NavigationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "stats-reports",
    component: StatsReportsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "add-company",
    component: AddCompanyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "add-region",
    component: AddRegionComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "add-city",
    component: AddCityComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "add-area",
    component: AddAreaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "trainer-contract",
    component: TrainerContractComponent,
    canActivate: [AuthGuard],
  },
  { path: "coach", loadChildren: () => import("./pages/coach/coach.module").then(m => m.CoachModule), canActivate: [AuthGuard] },
  { path: "masters", loadChildren: () => import("./pages/all-masters/masters.module").then(m => m.MastersModule), canActivate: [AuthGuard] },
  { path: "student", loadChildren: () => import("./pages/student/student.module").then(m => m.StudentModule), canActivate: [AuthGuard] },
  { path: "class-list", loadChildren: () => import("./pages/class/class.module").then(m => m.ClassModule), canActivate: [AuthGuard] },
  { path: "report", loadChildren: () => import("./pages/report/report.module").then(m => m.ReportModule), canActivate: [AuthGuard] },

  {
    path: "inquiry-form",
    component: InquiryFormComponent,
  },
  {
    path: "inquiries",
    component: InquiryDataComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "events",
    component: EventListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "add-event",
    component: AddEventComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "event-registration",
    component: EventRegComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "orders",
    component: OrdersListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "add-order",
    component: AddOrderComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "order-status",
    component: OrderStatusComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "products",
    component: ProductListComponent,
    canActivate: [AuthGuard],
  },
];
